import { Box, IconButton, Modal, Tooltip, Typography } from '@mui/material';
import WalletIconWithBadge from './WalletIconWithBadge';
import CloseIcon from '@mui/icons-material/Close';
import CustomText from './CustomText';
import { Send } from '@mui/icons-material';
import SendCrypto from '../TransactionForm/Send/SendCrypto';
import { useState } from 'react';
import { truncateMiddle } from '../../helpers/constant';
import AddNewAddress from './AddNewAddress';
import ActionConfirmModal from '../common/ActionConfirmModal';
import { apiService } from '../../../client/common/apiCallService';
import { useSelector } from 'react-redux';
import TransactionStatus from '../TransactionStatus';
import CopyButton from '../common/CopyButton';
import PropTypes from 'prop-types';
import { filterBalances } from '../../../client/Juno/helpers';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { DeleteOutlined } from '@mui/icons-material';
import clsx from 'clsx';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 600,
    bgcolor: 'var(--common-modal-bg)',
    boxShadow: 24,
    borderRadius: 2,
    p: 3,
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
};

const ManageWalletAddress = ({
    addressNickName,
    address,
    cryptoName,
    onClose,
    open,
    cryptoId,
    addressId,
    getCryptoAddress,
    blockchain,
}) => {
    const [modals, setModals] = useState({
        openManage: true,
        openSend: false,
        openAddNewAddress: false,
        openDeleteModal: false,
    });

    const [loading, setLoading] = useState(false);
    const apiUrl = useSelector(state => state.config.api_url);

    const [status, setStatus] = useState({
        status: '',
        message: '',
        open: false,
    });

    const { unfreezeCryptoCurrencies } = useSelector(state => state.juno);
    const updatedUnfreeze = filterBalances(unfreezeCryptoCurrencies);
    const clientData = useSelector(state => state.juno.clientData);
    const { readOnly } = clientData || {};

    const deleteAddress = async (setParentStatus, setParentLoading) => {
        (setParentLoading || setLoading)(true);

        await apiService(
            (window.location.hostname === 'localhost' ? apiUrl : '') +
                '/restapi/delete-crypto-address',
            { addressId },
            async response => {
                (setParentStatus || setStatus)({
                    status: 'success',
                    message: 'Deleted address successfully',
                    open: true,
                });
                await getCryptoAddress();
            },
            err => {
                console.log(err);
                (setParentStatus || setStatus)({
                    status: 'error',
                    message: 'Failed to delete successfully',
                    open: true,
                });
            },
        );
        (setParentLoading || setLoading)(false);
    };

    const disabledSend = !updatedUnfreeze?.find(balance => balance.currencyShortName == cryptoId);

    return (
        <>
            {modals.openManage && !status.open ? (
                <Modal
                    open={open}
                    onClose={onClose}
                    aria-labelledby="transaction-modal-title"
                    className="overflow-visible">
                    <Box sx={style}>
                        <div className="self-stretch flex flex-col justify-start items-start gap-12">
                            <div className="self-stretch flex flex-col justify-start items-start gap-9">
                                <div className="self-stretch flex flex-col justify-center items-start gap-3">
                                    <div className="self-stretch relative inline-flex justify-start items-center gap-3">
                                        <WalletIconWithBadge
                                            cryptoId={cryptoId}
                                            height={10}
                                            width={10}
                                            iconDimension={26}
                                            imageDimension={5}
                                            className="!bg-card-bg"
                                        />
                                        <div className="flex-1 inline-flex flex-col justify-center items-start">
                                            <div className="justify-center !text-text text-xl font-semibold  uppercase leading-loose tracking-tight">
                                                {`${addressNickName}'s Crypto Wallet`}
                                            </div>
                                            <div className="self-stretch justify-start text-balanceCard-manage text-sm font-medium  uppercase leading-tight">
                                                {truncateMiddle(address, 20)}
                                            </div>
                                        </div>
                                        {onClose && (
                                            <IconButton
                                                onClick={onClose}
                                                aria-label="close"
                                                sx={{
                                                    position: 'absolute',
                                                    right: 0,
                                                    top: 0,
                                                }}>
                                                <CloseIcon className="!text-primary" />
                                            </IconButton>
                                        )}
                                    </div>
                                </div>
                                <div className="self-stretch flex flex-col justify-start items-start gap-3">
                                    <CustomText
                                        heading={'Select crypto'}
                                        text={cryptoName}
                                        textUp={true}
                                    />
                                    <div className="self-stretch h-px bg-[#D1D1D6] dark:bg-[#51525C]" />
                                    <CustomText
                                        heading={'wallet address'}
                                        text={address}
                                        addCopyButton={true}
                                    />
                                    <div className="self-stretch h-px bg-[#D1D1D6] dark:bg-[#51525C]" />
                                    <CustomText
                                        heading={'nickname'}
                                        text={addressNickName}
                                        addCopyButton={true}
                                    />
                                </div>
                            </div>
                            <div
                                className="self-stretch inline-flex justify-between items-center"
                                onClick={() => {}}>
                                <div className="flex justify-start items-center gap-2">
                                    <Tooltip arrow placement="top" title={'EDIT'}>
                                        <div
                                            className={clsx(
                                                'w-11 p-2.5 !bg-secondary rounded-lg flex justify-center items-center gap-1 cursor-pointer',
                                                readOnly && '!cursor-not-allowed opacity-50 ',
                                            )}
                                            onClick={() => {
                                                if (readOnly) return;
                                                setModals(prev => ({
                                                    ...prev,
                                                    openAddNewAddress: true,
                                                    openManage: false,
                                                }));
                                            }}>
                                            <EditOutlinedIcon className="text-[#18181B] dark:text-[#FFF]" />
                                        </div>
                                    </Tooltip>
                                    <Tooltip arrow placement="top" title={'DELETE'}>
                                        <div
                                            className={clsx(
                                                'w-11 p-2.5 !bg-secondary rounded-lg flex justify-center items-center gap-1 cursor-pointer',
                                                readOnly && '!cursor-not-allowed opacity-50 ',
                                            )}
                                            onClick={() => {
                                                if (readOnly) return;
                                                setModals(prev => ({
                                                    ...prev,
                                                    openDeleteModal: true,
                                                    openManage: false,
                                                }));
                                            }}>
                                            <DeleteOutlined className="text-[#18181B] dark:text-[#FFF]" />
                                        </div>
                                    </Tooltip>
                                </div>
                                <div
                                    className={clsx(
                                        'flex justify-start items-center gap-2',
                                        disabledSend || readOnly
                                            ? 'opacity-50 cursor-not-allowed'
                                            : 'cursor-pointer',
                                    )}
                                    onClick={() => {
                                        if (readOnly) return;

                                        !disabledSend &&
                                            setModals(prev => ({
                                                ...prev,
                                                openSend: true,
                                                openManage: false,
                                            }));
                                    }}>
                                    <div
                                        className={clsx(
                                            'w-11 p-2.5 !bg-secondary rounded-lg flex justify-center items-center gap-1',
                                            readOnly && '!cursor-not-allowed opacity-50 ',
                                        )}>
                                        <Tooltip arrow placement="top" title={'SEND'}>
                                            <Send sx={{ color: 'var(--color-primary)' }} />
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>
                </Modal>
            ) : null}
            {modals.openSend ? (
                <SendCrypto
                    isModal={true}
                    onClose={() => onClose()}
                    row={{ currencyShortName: cryptoId, address, blockchain }}
                    parentOnBack={() =>
                        setModals(prev => ({
                            ...prev,
                            openSend: false,
                            openManage: true,
                        }))
                    }
                    parentGetCryptoAddress={getCryptoAddress}
                />
            ) : null}
            {modals.openAddNewAddress ? (
                <AddNewAddress
                    close={() => onClose()}
                    onBack={() =>
                        setModals(prev => ({
                            ...prev,
                            openAddNewAddress: false,
                            openManage: true,
                        }))
                    }
                    back={true}
                    open={true}
                    heading={'edit address'}
                    bottomText={'save'}
                    mode={'edit'}
                    address={address}
                    addressNickName={addressNickName}
                    addressId={addressId}
                    deleteAddress={deleteAddress}
                    getCryptoAddress={getCryptoAddress}
                    setParentModals={setModals}
                />
            ) : null}
            {modals.openDeleteModal && !status.open ? (
                <ActionConfirmModal
                    open={modals.openDeleteModal}
                    heading={'Delete Address!'}
                    subHeading={'Are you sure you want to delete the address?'}
                    onCancel={() =>
                        setModals(prev => ({
                            ...prev,
                            openDeleteModal: false,
                            openManage: true,
                        }))
                    }
                    onConfirm={() => deleteAddress()}
                    loading={loading}
                    type={'delete'}
                    actionButtonText="delete"
                    body={() => (
                        <div className="self-stretch inline-flex justify-start items-center gap-2">
                            <div className="flex-1 justify-center !text-text text-base font-semibold leading-normal">
                                {truncateMiddle(address, 20)}
                            </div>
                            <CopyButton copyValue={address} />
                        </div>
                    )}
                />
            ) : null}
            {status.open ? (
                <TransactionStatus
                    onClick={() => {
                        onClose();
                    }}
                    description={status.message}
                    status={status.type}
                />
            ) : null}
        </>
    );
};

ManageWalletAddress.propTypes = {
    addressNickName: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    cryptoName: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    cryptoId: PropTypes.string.isRequired,
    addressId: PropTypes.string.isRequired,
    getCryptoAddress: PropTypes.func.isRequired,
};

export default ManageWalletAddress;
